import { render, staticRenderFns } from "./PollNumberEditorStars.vue?vue&type=template&id=0a4c55ef&scoped=true"
import script from "./PollNumberEditorStars.vue?vue&type=script&lang=js"
export * from "./PollNumberEditorStars.vue?vue&type=script&lang=js"
import style0 from "./PollNumberEditorStars.vue?vue&type=style&index=0&id=0a4c55ef&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0a4c55ef",
  null
  
)

export default component.exports